import React from "react";
const IconDiamond = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
    <path
      d="M15.2941 3H4.70588L1 7.66667L10 17L19 7.66667L15.2941 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path d="M1 7.5H18.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M8 3L6.5 7.5L10 17" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M12 3L13.5 7.5L10 17" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconDiamond;
